module.exports.sortItensByInterest = (items, sort) => {
    var newItems = [];

    sort.map((item) => {
        items.map((i) => {
            if (Object.values(i).includes(item)) {
                i.suggested = true;
                newItems.push(i);
            }
            return true;
        });
        return true;
    });

    return newItems;
}
